var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "./base";
import { Icon } from "./chat/icon";
var ErrorTextArea = /** @class */ (function (_super) {
    __extends(ErrorTextArea, _super);
    function ErrorTextArea(onCloseAction) {
        var _this = _super.call(this) || this;
        var textArea = document.createElement('div');
        textArea.id = 'js_aigo_bot_error_text_area';
        textArea.style.backgroundColor = "".concat(process.env.AIGO_DEFAULT_BACKGROUND_COLOR);
        textArea.style.boxShadow = '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)';
        textArea.style.display = 'inline-block';
        textArea.style.borderRadius = '5px';
        textArea.style.height = 'fit-content';
        textArea.style.width = '120px';
        textArea.style.padding = '10px';
        var header = document.createElement('div');
        header.id = 'js_aigo_bot_error_text_area_header';
        var closeWindowIcon = new Icon('js_aigo_bot_error_close_bot', "data:image/svg+xml;base64, ".concat(process.env.AIGO_CHAT_HEADER_CLOSE_WINDOW_ICON_IN_BASE64), '9px', '9px', '#000000', null, onCloseAction, false, 'Close window');
        header.appendChild(closeWindowIcon.self);
        textArea.appendChild(header);
        var text = document.createElement('div');
        text.id = 'js_aigo_bot_error_text_area_text';
        text.innerHTML = "".concat(process.env.AIGO_INITIALIZATION_ERROR_MESSAGE);
        text.style.fontSize = '15px';
        textArea.appendChild(text);
        _this.self = textArea;
        return _this;
    }
    return ErrorTextArea;
}(Base));
export { ErrorTextArea };
